import { render, staticRenderFns } from "./Wameedloading.vue?vue&type=template&id=3a3400ed&"
import script from "./Wameedloading.vue?vue&type=script&lang=js&"
export * from "./Wameedloading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports